export default "__VITE_ASSET__650a2a41__"